<!-- Due to https://cimenviro.atlassian.net/browse/AP-3466 need to test explicitly for not null status_id rather than just status -->
@if (ticket?.status?.status_id != null) {
  <span class="badge rounded-pill"
        [ngClass]="badgeColourStyle"
        [ngStyle]="{'font-size': fontSize}">
    @if (!hidePriority && isHighPriority(ticket)) {
      <fa-icon icon="exclamation-triangle"
               [fixedWidth]="true"
               [ngClass]="ticket.status.status_id === TicketStatusId.STATUS_ON_HOLD ? 'text-white' : 'text-warning'"/>
    }
    {{ displayText | messageTranslate }}
    @if (contentTemplate && contentPosition === 'inside') {
      <span>
        <ng-template [ngTemplateOutlet]="contentTemplate"/>
      </span>
    }
  </span>
}

@if (contentTemplate && contentPosition === 'outside') {
  <span class="ms-1">
    <ng-template [ngTemplateOutlet]="contentTemplate"/>
  </span>
}
